export default {
  suppressedEmails: state => state.suppressedEmails,
  isLoading: state => state.isLoading,
  hasError: state => !!state.error,
  error: state => state.error
};